import { Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { NoPropertyState } from '@/components/NoPropertyState';

/**
 * Layout route guarding property-scoped pages. A verified user with no
 * property is allowed into the app shell (see ProtectedRoute), but the
 * individual property-scoped screens have no property to load, so this
 * renders a shared "create your property" empty state instead of letting
 * their API calls fail. Once a property exists, it simply renders the
 * matched child route.
 */
export function RequireProperty() {
  const { user } = useAuth();

  if (user && !user.property) {
    return <NoPropertyState />;
  }

  return <Outlet />;
}
